import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import globals from '@/config/globals';
import store from '@/store';
import dashboardRoutes from './dashboards';
import managementRoutes from './management';
import areaRoutes from './area';
import alarmRoutes from './alarm';
import mapRoutes from './map';
import settingRoutes from './settings';
import reportRoutes from './report';
import publicUrls from './publicUrls';
import pages from './pages';
import requestSupport from './requestSupport';
import vehicleContractTracking from './vehicleContractTracking';

Vue.use(Router);
Vue.use(Meta);

const ROUTES = [{ path: '', redirect: '/dashboard' }]
  .concat(dashboardRoutes)
  .concat(managementRoutes)
  .concat(areaRoutes)
  .concat(alarmRoutes)
  .concat(mapRoutes)
  .concat(settingRoutes)
  .concat(reportRoutes)
  .concat(pages)
  .concat(publicUrls)
  .concat(requestSupport)
  .concat(vehicleContractTracking)
  .concat(
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/Login'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/Register'),
    }
  );
const router = new Router({
  base: '/',
  mode: 'history',
  routes: ROUTES,
});

router.afterEach(() => {
  const splashScreen = document.querySelector('.app-splash-screen');
  if (splashScreen) {
    splashScreen.style.opacity = 0;
    setTimeout(() => splashScreen && splashScreen.parentNode.removeChild(splashScreen), 300);
  }
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10);
  }
  globals().scrollTop(0, 0);
});

router.beforeEach((to, from, next) => {
  document.body.classList.add('app-loading');
  const publicPages = ['/login', '/liveView', '/other_screens', '/token'];
  let authRequired = !publicPages.includes(to.path);
  let loginUrl = '/login';
  let gateway = false;
  if (!store.getters.user.authenticated && authRequired) {
    window.location.href = loginUrl;
  } else if (to.meta.perm && !store.getters.permissions.includes(to.meta.perm)) {
    next(loginUrl);
  } else if (store.getters.user.authenticated && to.path === '/login') {
    next('/dashboard');
  } else if (!store.getters.user.authenticated && to.path === '/login' && gateway) {
    window.location.href = loginUrl;
  } else {
    store.commit('change_page', to.path);
    next();
  }
  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10);
});

export default router;
